import { atom, useAtom } from "jotai";
import { useEffect } from "react";
import { DateTime } from "luxon";
import tools from "../../../../helpers/tools";
import dataService from "../../../../helpers/dataService";

const ROLE_STYLES = {
  admin:         { label: "Admin",         color: "#6c5ce7", bg: "#efebfd" },
  gestionnaire:  { label: "Gestionnaire",  color: "#0f9b8e", bg: "#e3f6f4" },
  collaborateur: { label: "Collaborateur", color: "#3e75ff", bg: "#e9f0ff" },
  social:        { label: "Social",        color: "#d6336c", bg: "#fdebf1" },
  partenaire:    { label: "Partenaire",    color: "#e47d21", bg: "#fdf1e6" },
};
const DEFAULT_ROLE_STYLE = { color: "#6e6e71", bg: "#f2f3fa" };

const getRoleStyle = (role) => {
  const known = ROLE_STYLES[(role || "").toLowerCase()];
  return known || { ...DEFAULT_ROLE_STYLE, label: role || "—" };
};

const formatDate = (iso) =>
  DateTime.fromISO(iso).setLocale("fr").toFormat("d MMMM yyyy");

export const isUserExpired = (user) =>
  !!user.contractEndAt &&
  DateTime.now().startOf("day") > DateTime.fromISO(user.contractEndAt).startOf("day");

// Shared across all UserCard instances — fetched once, reused by every card.
const gestionnairesAtom = atom([]);

const useUserCard = (user) => {
  const [gestionnaires, setGestionnaires] = useAtom(gestionnairesAtom);

  useEffect(() => {
    if (gestionnaires.length === 0) {
      dataService.get("constants/gestionnaires", setGestionnaires);
    }
  }, []);

  const roleStyle = getRoleStyle(user.role);
  const nomSociete = tools.findIn(gestionnaires, user.producer, "id").nomSociete;
  const genderPrefix = tools.getGender(user.gender);
  const fullName = `${tools.capitalize((user.firstname + "").toLowerCase())} ${(user.lastname + "").toUpperCase()}`;

  const contractStatus = {
    isOngoing: !user.contractEndAt,
    isExpired: isUserExpired(user),
    date: user.contractEndAt ? formatDate(user.contractEndAt) : null,
  };

  return {
    roleStyle,
    nomSociete,
    genderPrefix,
    fullName,
    createdAt: formatDate(user.createdAt),
    updatedAt: formatDate(user.updatedAt),
    contractStatus,
  };
};

export default useUserCard;
